import { pluralForm } from "../i18n/quotaCopy";

function unitWord(t, locale, count, unit) {
  return pluralForm(locale, count, {
    one: t(`unit.${unit}.one`),
    few: t(`unit.${unit}.few`),
    many: t(`unit.${unit}.many`),
  });
}

function agePhrase(t, locale, ageDisplay) {
  const raw = String(ageDisplay || "").trim();
  if (!raw || raw === "—") return "";
  const months = raw.match(/^(\d+)\s*mo$/i);
  if (months) {
    const age = Number(months[1]);
    return t("subjects.ageMonths")
      .replace("{age}", String(age))
      .replace("{monthsLabel}", unitWord(t, locale, age, "month"));
  }
  const years = raw.match(/^(\d+)$/);
  if (!years) return raw;
  const age = Number(years[1]);
  return t("subjects.ageYears")
    .replace("{age}", String(age))
    .replace("{yearsLabel}", unitWord(t, locale, age, "year"));
}

function listSegments(t, locale, count, fieldKey, unit, field) {
  if (count == null) {
    return [
      { type: "text", text: `${t(fieldKey)}: ` },
      { type: "safety", field, text: t("subjects.notProvided") },
    ];
  }
  const n = Number(count) || 0;
  return [{ type: "text", text: `${n} ${unitWord(t, locale, n, unit)}` }];
}

function summarySegments(t, locale, subject) {
  const chunks = [];
  const age = agePhrase(t, locale, subject?.age_display);
  if (age) chunks.push([{ type: "text", text: age }]);
  chunks.push(
    listSegments(
      t,
      locale,
      subject?.medications_count,
      "healthProfile.medications",
      "medication",
      "medications",
    ),
  );
  chunks.push(
    listSegments(
      t,
      locale,
      subject?.allergies_count,
      "healthProfile.allergies",
      "allergy",
      "allergies",
    ),
  );
  const segments = [];
  chunks.forEach((chunk) => {
    if (!chunk.length) return;
    if (segments.length) segments.push({ type: "text", text: ", " });
    segments.push(...chunk);
  });
  return segments;
}

/**
 * Sentence parts for the profile toggle. Missing medication and allergy
 * lists are safety links ("Not provided") rather than a zero count.
 */
export function profileToggleSegments(t, locale, subject) {
  const template =
    subject?.kind === "self"
      ? t("subjects.useMyProfile")
      : t("subjects.useNamedProfile");
  const named = template.replace("{name}", subject?.display_name || "");
  const marker = "{summary}";
  const at = named.indexOf(marker);
  const before = at === -1 ? named : named.slice(0, at);
  const after = at === -1 ? "" : named.slice(at + marker.length);
  const segments = [];
  if (before) segments.push({ type: "text", text: before });
  segments.push(...summarySegments(t, locale, subject));
  if (after) segments.push({ type: "text", text: after });
  return segments;
}

/** Plain-text form of the profile toggle sentence. */
export function profileToggleLabel(t, locale, subject) {
  return profileToggleSegments(t, locale, subject)
    .map((segment) => segment.text)
    .join("");
}
